// ====================================================================
// APPLY EDIT LAYER — shared iteration order for live + baked application
// ====================================================================
// One place that defines HOW an edit layer is replayed onto a freshly-built
// procedural world: terrain first, then prop removals, prop additions, added
// structures/signs, then transform/text overrides for existing objects. Both
// callers — the live editor (worldEdit.js, with undo bookkeeping) and the baked
// startup path (main.js, before the chunk-build loop) — pass their own runtime
// primitives via `api`, so the apply order can never drift between authoring and
// the shipped result while each context keeps its appropriate primitives.
//
// Core-safe: no THREE, no DOM, no build-flag or side-effect assumptions. Every
// api hook is optional — a caller that doesn't support a capability just omits
// it, and that section is skipped.
export function applyEditLayer(layer, api = {}) {
  if (!layer) return;
  const t = layer.terrain;
  if (t && Object.keys(t).length && api.applyTerrain) api.applyTerrain(t);
  for (const id of layer.propsRemoved || []) api.removeProp && api.removeProp(id);
  for (const e of layer.propsAdded || []) api.addProp && api.addProp(e);
  for (const s of layer.structuresAdded || []) api.addStructure && api.addStructure(s);
  for (const s of layer.signsAdded || []) api.addSign && api.addSign(s);
  for (const name in (layer.structures || {})) api.xformStructure && api.xformStructure(name, layer.structures[name]);
  for (const key in (layer.signs || {})) api.xformSign && api.xformSign(key, layer.signs[key]);
  if (api.afterApply) api.afterApply();
}
